function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["children", "title", "handleClose", "id", "size", "removePadding", "className", "isOpen"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { func, bool, node, string, oneOf } from 'prop-types';
import classNames from 'classnames';
import './BaseModal.scss';
import Button from '../../Button';
import FocusLock from 'react-focus-lock';
import Portal from '../../Portal';
import { CrossIcon } from '@ruter-ds/rds-icons';
var propTypes = {
  /** Callback function for closing the modal */
  handleClose: func,

  /** Shows the modal window */
  isOpen: bool,
  children: node,

  /** The title of the modal */
  title: string,

  /** Removes the padding on the modal content */
  removePadding: bool,

  /** Adjust the size of the modal */
  size: oneOf(['small', 'medium', 'large']),
  id: string,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  type: 'default',
  size: 'medium'
};
var ESC_KEY = 27;

var BaseModal = /*#__PURE__*/function (_Component) {
  _inherits(BaseModal, _Component);

  var _super = _createSuper(BaseModal);

  function BaseModal(props) {
    var _this;

    _classCallCheck(this, BaseModal);

    _this = _super.call(this, props);
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.modalTitle = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(BaseModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        document.body.classList.add('rds-has-open-modal');
        this.modalTitle.current.focus();
      } else {
        document.body.classList.remove('rds-has-open-modal');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.isOpen !== this.props.isOpen) {
        if (this.props.isOpen) {
          document.body.classList.add('rds-has-open-modal');
          this.modalTitle.current.focus();
        } else {
          document.body.classList.remove('rds-has-open-modal');
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove('rds-has-open-modal');
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.keyCode === ESC_KEY) {
        this.props.handleClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          handleClose = _this$props.handleClose,
          id = _this$props.id,
          size = _this$props.size,
          removePadding = _this$props.removePadding,
          className = _this$props.className,
          isOpen = _this$props.isOpen,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var componentClassNames = classNames('rds-base-modal', {
        'rds-base-modal--open': isOpen,
        'rds-base-modal--small': size === 'small',
        '': size === 'medium',
        'rds-base-modal--large': size === 'large',
        'rds-base-modal--no-pad': removePadding
      }, className);
      if (!isOpen) return null;
      return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(FocusLock, null, /*#__PURE__*/React.createElement("div", _extends({
        className: componentClassNames,
        onKeyDown: this.handleKeyDown,
        tabIndex: "-1",
        ref: this.modalTitle
      }, rest), /*#__PURE__*/React.createElement("div", {
        className: "rds-base-modal__overlay",
        onClick: handleClose
      }), /*#__PURE__*/React.createElement("div", _extends({
        className: "rds-base-modal__content",
        role: "dialog",
        "aria-modal": "true"
      }, title && {
        'aria-labelledby': "".concat(id, "-title")
      }, {
        "aria-describedby": "".concat(id, "-desc")
      }), children, /*#__PURE__*/React.createElement(Button, {
        text: 'X',
        onClick: handleClose,
        shape: "pill",
        iconLeft: /*#__PURE__*/React.createElement(CrossIcon, null),
        hideText: true,
        size: 'medium',
        className: 'rds-base-modal__close'
      })))));
    }
  }]);

  return BaseModal;
}(Component);

BaseModal.propTypes = propTypes;
BaseModal.defaultProps = defaultProps;
export default BaseModal;